export default __webpack_public_path__ + "static/media/animation021-01.4c9b97e3.svg";